import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { INettingPrelevement } from 'src/app/shared/models/netting-prelevement';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { NettingPrelevementService } from '../netting-prelevement.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-netting-prelevement-form',
  templateUrl: './netting-prelevement-form.component.html',
  styleUrls: ['./netting-prelevement-form.component.less']
})
export class NettingPrelevementFormComponent implements OnInit, OnChanges {

  formGroup: UntypedFormGroup;

  btnStatus = false;
  asEdited = false;

  @Input()
  nettingPrelevement!: INettingPrelevement;

  @Output()
  updateEvent = new EventEmitter<INettingPrelevement>();

  @Output()
  clearEvent = new EventEmitter<any>();

  constructor(private _fb: UntypedFormBuilder, private snackbarService: SnackbarService,
    private dialogService: DialogService,
    private _npa: NettingPrelevementService,
    public authenticationService: AuthenticationService,
    public theme: ThemeService) {
    this.formGroup = this._fb.group({
      id: [''],
      prelevement_name: ['', Validators.required],
      date_second_rate: [''],
      isEnabled: [false]
    })

  }

  ngOnInit(): void {
    console.log('ngOnInit');
  }

  updateFormGroup() {
    const pUpdate = {
      id: this.nettingPrelevement.id,
      prelevement_name: this.nettingPrelevement.prelevement_name,
      date_second_rate: this.nettingPrelevement.date_second_rate,
      isEnabled: this.nettingPrelevement.isEnabled
    }
    this.formGroup.setValue(pUpdate);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.nettingPrelevement) {
      return;
    } // TODO : a reprendre
    this.asEdited = false;
    if (!this.nettingPrelevement || this.nettingPrelevement.isEnabled && this.nettingPrelevement.prelevement_name === '') {
      this.updateFormGroup();
      this.asEdited = false;
      this.btnStatus = false;
    } else if (this.nettingPrelevement.isEnabled && this.nettingPrelevement.prelevement_name != '') {
      this.updateFormGroup();
      this.asEdited = true;
      this.btnStatus = false;

    } else if (!this.nettingPrelevement.isEnabled && this.nettingPrelevement.prelevement_name != '') {
      this.updateFormGroup();
      this.asEdited = false;
      this.btnStatus = true;

    }
  }

  onSubmit() {
    if (!this.asEdited && !this.btnStatus) {
      this._npa.createNettingsPrelevement(this.formGroup.value).subscribe({
        next: data => {
          this.updateEvent.emit(data);
          this.formGroup.reset();
          this.openSuccessSnackBar("Le compte de netting a été créé avec succès")
        },
        error: err => {
          console.log(err)
          this.openErrorSnackBar("Le compte de netting n'a pas été créé")
        },
        complete: () => {
        }
      });
    } else if (!this.asEdited && this.btnStatus) {
      const updateData = { ...this.formGroup.value, id: this.nettingPrelevement.id ?? '' };
      this._npa.updateNettingsPrelevement(updateData).subscribe({
        next: data => {
          this.updateEvent.emit(data);
          this.formGroup.reset();
          this.asEdited = false;
          this.btnStatus = false
          this.openSuccessSnackBar("Le compte de netting a été modifié avec succès")
        },
        error: err => {
          console.log(err)
          this.openErrorSnackBar("Le compte de netting n'a pas été modifié")
        },
        complete: () => {
        }
      })
    }
  }

  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }

  clear(): void {
    this.formGroup.reset();
    this.asEdited = false;
    this.btnStatus = false
    this.clearEvent.emit();
  }

  is_edit(asEdited: boolean) {
    asEdited = !asEdited
    this.asEdited = asEdited
    this.btnStatus = true
  }

  confirmDelete() {
    this.dialogService.openConfirmDialog(this.nettingPrelevement.prelevement_name).afterClosed().subscribe((res) => {
      if (res) {
        this.deleteNettingPrelevement();
      }
    });
  }

  deleteNettingPrelevement() {
    if (this.asEdited) {
      this._npa.deleteNettingsPrelevement(this.nettingPrelevement).subscribe({
        next: data => {
          this.clear();
          this.updateEvent.emit(data);
        },
        error: error => {
          this.openErrorSnackBar(
            "Erreur lors de la suppression du Netting Prélèvement : " + error.message)
        }
      })
    }
  }
}
